import { createSelector } from "reselect"
import { get, keyBy, find, chain, map } from "lodash"
import { getAllResourcesStatuses } from "selectors/data"
import { areResourcesLoading } from "helpers/data-statuses"

export const defaultPortfolioBenchmark = ""
export const getPortfolios = state => get(state, "global.data.portfolios.data")
export const getPortfolioBenchmark = state => get(state, "global.data.portfolioModelMeta.data.defaultBenchmark", defaultPortfolioBenchmark)
const getBenchmarks = state => get(state, "global.data.benchmarksAndPortfolios.data.model.benchmarks")
export const getPortfoliosMetadata = state => get(state, "global.data.benchmarksAndPortfolios.data.portfolios")

const getLastViewedRaw = state => {
  const account = get(state, "global.selected.account")
  if (account) {
    return localStorage.getItem(`OP_${account}_LastPortfolios`)
  }
}

export const getPortfoliosWithMetadata = createSelector(
  [getPortfolios, getPortfoliosMetadata],
  (portfolios, portfoliosMetadata) =>
    map(portfolios, portfolio => ({
      ...portfolio,
      availableFrom: get(find(portfoliosMetadata, { id: portfolio.id }), "availableFrom"),
    })),
)

export const getPortfoliosLookup = createSelector(
  [getPortfolios],
  (portfolios) => chain(portfolios)
    .keyBy("id")
    .mapValues(p => ({
      name: p.name,
      alias: p.shortId,
      experiments: p.experiments,
    }))
    .value(),
)

export const getLastViewed = createSelector(
  [getLastViewedRaw],
  (lastViewed) => {
    if (lastViewed) {
      return JSON.parse(lastViewed)
    } else {
      return []
    }
  },
)

export const getBenchmarksLookup = createSelector(
  [getBenchmarks],
  (benchmarks) => keyBy(benchmarks, benchmark => benchmark.id),
)

export const getIsPortfolioFiltersLoading = createSelector(
  [getAllResourcesStatuses],
  (statuses) => areResourcesLoading("portfolioFilters", statuses),
)
